import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Txt, View } from 'components';
import { useUIState } from 'state';
import styles from './Nav.module.scss';

/**
 * Nav
 *
 * @return {JSX.Element}
 */
const Nav = ({
  className,
  routes,
  classNameNavLink,
  classNameNavLinkActive,
}) => {
  const uiState = useUIState();
  const handleNavigation = () =>
    uiState.isMobile && uiState.setIsSideBarClosed(true);

  return (
    <View className={classNames(styles.Nav, className, `${Nav.displayName}`)}>
      {routes.map((r) => (
        <NavLink
          key={r.path}
          to={r.path}
          className={({ isActive }) =>
            classNames(
              styles.NavLink,
              classNameNavLink,
              isActive && styles.NavLinkActive
            )
          }
          onClick={handleNavigation}
        >
          <Txt>{r.title}</Txt>
        </NavLink>
      ))}
    </View>
  );
};

Nav.displayName = 'Nav';

export default Nav;
